export default __webpack_public_path__ + "static/media/dash1.27e2ee50.jpg";